module.exports = __webpack_public_path__ + "img/touchScreen.66fc4e76.png";